import { useEffect } from "react";

import { useStore as useOldStore } from "../../../../hooks/useStore";
import { useStore } from "../../../stores/AppStore";
import { useRouter } from "../../common/hooks/useRouter";
import { useMutation, useQuery } from "react-query";

import { getShippingServices } from "../../address/services/shippingServices.requests";
import { deleteLocalStorageValue } from "../../common/utils/localStorage.utils";
import { getCountries } from "../../common/services/countries.requests";
import { getCarriers } from "../../carriers/services/carrier.requests";
import { getHolidays } from "../../common/services/dates.requests";
import { getUser } from "../../user/services/user.requests";
import { userLogout } from "../services/session.requests";
import {
  deleteCookieValue,
  getCookieValue,
} from "../../common/utils/cookie.utils";

import { SESSION_QUERY_KEYS } from "../constants/session.consts";

import { User } from "../../../api/models";

//? TODO: eliminar todo uso de la store vieja cuando migremos todo
export const useSession = (oldStore) => {
  const deprecatedStore = useOldStore();

  const store = useStore();
  const router = useRouter();

  const appStore = oldStore || deprecatedStore;

  const tokenStoraged = getCookieValue("sn_loggin_user_token");
  const userIdStoraged = getCookieValue("sn_loggin_user_id");

  //? open session.
  const { isLoading, refetch } = useQuery({
    enabled: false,
    queryKey: SESSION_QUERY_KEYS.loggedUser(),
    queryFn: () => {
      const params = {
        fields: "account.onboarding",
      };

      return getUser(userIdStoraged, params);
    },
    onSuccess: (res) => {
      res.results.token = tokenStoraged;
      handleLoginOfUser(res.results);
    },
    onError: () => {
      handleUserLogout();
    },
  });

  //? close session.
  const logoutMutation = useMutation({
    mutationFn: () => {
      return userLogout();
    },
    onSuccess: () => {
      deleteCookieValue("sn_loggin_user_token");
      deleteCookieValue("sn_loggin_user_id");
      deleteLocalStorageValue("sn_salesforce_token");

      store.user.logout();
      appStore.signOut();

      router.push("/session/signin");
    },
  });

  useEffect(() => {
    store.user.setIsLoading(isLoading);
  }, [isLoading]); // eslint-disable-line

  const handleLoginWithCookie = () => {
    if (!!tokenStoraged && !!tokenStoraged && !store.user.loggedInUser) {
      refetch();
    }
  };

  const handleUserLogout = () => {
    logoutMutation.mutate();
  };

  const handleUpdateOnboarding = (account) => {
    const newUser = Object.assign({}, store.user.loggedInUser, { account });
    const instancedUser = new User(newUser);

    appStore.loggedInUser.company.onboarding = account.onboarding;
    appStore.loggedInUser.company.picking_preference_own =
      account.picking_preference_own;

    store.user.setCurrentUser(instancedUser);
  };

  const handleLoginOfUser = async (user) => {
    const shippingServices = await getShippingServices();
    const carriers = await getCarriers();
    const countries = await getCountries();
    const holidays = await getHolidays();

    const data = { user, shippingServices, carriers, countries, holidays };

    appStore.saveInfo(data);
    store.saveInfo(data);
  };

  const handleUpdateOfUser = (user) => {
    const userInstanced = new User(user);

    appStore.loggedInUser.avatar_url = user.avatar_url;
    appStore.loggedInUser.email = user.email;
    appStore.loggedInUser.name = user.name;
    appStore.loggedInUser.last_name = user.last_name;

    store.user.setCurrentUser(userInstanced);
  };

  return {
    handleUpdateOfUser,
    handleLoginOfUser,
    handleUpdateOnboarding,
    handleUserLogout,
    handleLoginWithCookie,
  };
};
